/**
 * One way to write dates and times across the worklist, whatever the browser's language: "Apr 26, 2023",
 * "Wednesday, October 21". Mixed locales (a French browser's "mercredi 21 octobre" next to English labels)
 * read as a bug.
 */
export const DATE_LOCALE = 'en-US';

/**
 * A DICOM date (`YYYYMMDD`) the way the rest of the app writes dates: "Nov 18, 2109". Whatever does not parse is
 * returned as it came, so a malformed header still shows something.
 */
export function formatDicomDate(dicomDate?: string): string {
  const match = /^(\d{4})(\d{2})(\d{2})$/.exec(dicomDate ?? '');
  if (!match) {
    return dicomDate ?? '';
  }
  const [, year, month, day] = match;
  return new Date(Date.UTC(+year, +month - 1, +day)).toLocaleDateString(DATE_LOCALE, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
